import { render, staticRenderFns } from "./ChildsBySexModal.vue?vue&type=template&id=326bf98f"
import script from "./ChildsBySexModal.vue?vue&type=script&lang=js"
export * from "./ChildsBySexModal.vue?vue&type=script&lang=js"
import style0 from "./ChildsBySexModal.vue?vue&type=style&index=0&id=326bf98f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports